module.exports = __webpack_public_path__ + "../resources/images/numbering-rtl-f58a7acdcc1603a2d732686b7a969de5.svg";